/**
 * Limita la quantitat a l'estoc disponible.
 *
 * El tema deixa l'input de quantitat sense cap limit, de manera que es podia
 * escriure 10 d'una talla que nomes en te 3. Shopify ho impedeix al carret
 * (les variants son `inventoryPolicy: DENY`, verificat: retorna "Debido a la
 * disponibilidad, solo se anadieron 3 articulos"), pero l'avis arribava tard i
 * despres d'haver-hi posat un numero que semblava acceptat.
 *
 * QUE FA. Manté el `max` de l'input igual a les unitats de la variant
 * seleccionada, i retalla el valor si se'n passa (a ma o amb el boto "+").
 *
 * ⚠️ El bloc de quantitat NO es torna a renderitzar en canviar de variant (no
 * porta `data-dynamic-variant-content`), de manera que el `max` inicial que
 * escriu el Liquid quedaria encallat al de la primera variant. Per aixo cal
 * actualitzar-lo aqui.
 *
 * L'estoc surt de `[data-variant-data]`, el JSON que el tema ja publica i
 * reescriu a cada canvi de variant.
 */
(function () {
  'use strict';

  function stockOf(form) {
    // Les unitats les publica `main-product.liquid` com a `--hb-stock` al
    // bloc de l'avis d'estoc.
    //
    // ⚠️ NO es pot llegir de `[data-variant-data]`: Shopify no exposa
    // `inventory_quantity` al JSON public (verificat — les claus arriben fins
    // a `inventory_management` i prou).
    var notice = form.querySelector('.product-inventory-notice');
    if (!notice) return null;

    var raw = getComputedStyle(notice).getPropertyValue('--hb-stock').trim();
    if (!raw) return null;

    var stock = parseInt(raw, 10);
    if (isNaN(stock)) return null;

    // `-1`: sense gestio d'inventari o es venen unitats sense estoc.
    return stock < 0 ? null : stock;
  }

  function apply(form) {
    var input = form.querySelector('.quantity-wrapper input[name="quantity"]');
    if (!input) return;

    var stock = stockOf(form);

    if (stock === null || stock <= 0) {
      input.removeAttribute('max');
      return;
    }

    input.setAttribute('max', stock);

    // Si el que hi havia escrit ja no hi cap, es retalla.
    var value = parseInt(input.value, 10);
    if (!isNaN(value) && value > stock) {
      input.value = stock;
    }
  }

  function watch(form) {
    if (form.dataset.hbQuantityMax) return;
    form.dataset.hbQuantityMax = '1';

    apply(form);

    // El boto "+" del tema i l'escriptura a ma: es retalla despres del canvi.
    form.addEventListener('input', function (evt) {
      if (evt.target.name === 'quantity') apply(form);
    });
    form.addEventListener(
      'click',
      function (evt) {
        if (evt.target.closest && evt.target.closest('[data-quantity]')) {
          setTimeout(function () {
            apply(form);
          }, 0);
        }
      },
      true
    );

    // Canvi de variant: el tema reescriu `[data-variant-data]`.
    new MutationObserver(function () {
      apply(form);
    }).observe(form, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    document.querySelectorAll('.product-detail__form').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
